import {
    Box,
    Flex,
    Spinner,
    Text,
} from "@chakra-ui/react";

import {
    useLocation,
    useNavigate,
} from "react-router-dom";

import {
    ArrowLeft,
} from "lucide-react";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";

const PolicyViewer = () => {
    const navigate =
        useNavigate();

    const {
        state,
    } = useLocation();

    const policy =
        state?.policy;

    if (
        !policy
    ) {
        return (
            <Flex
                h="100vh"
                justify="center"
                align="center"
                direction="column"
                gap={4}
            >
                <Spinner
                    size="lg"
                    color="#2453FF"
                />

                <Text
                    color="gray.500"
                >
                    Loading document...
                </Text>
            </Flex>
        );
    }

    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
        >
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <Text
                        display="flex"
                        alignItems="center"
                        gap={2}
                        cursor="pointer"
                        color="#2453FF"
                        mb={6}
                        fontWeight="600"
                        onClick={() =>
                            navigate(
                                -1
                            )
                        }
                    >
                        <ArrowLeft
                            size={18}
                        />
                        Back to Documents
                    </Text>

                    <Box
                        bg="white"
                        borderRadius="24px"
                        border="1px solid"
                        borderColor="gray.100"
                        p={{
                            base: 5,
                            md: 8,
                        }}
                    >
                        <Text
                            fontSize={{
                                base: "2xl",
                                md: "4xl",
                            }}
                            fontWeight="700"
                            color="#2453FF"
                            mb={4}
                        >
                            {
                                policy.title
                            }
                        </Text>

                        <Text
                            color="gray.500"
                            mb={8}
                        >
                            Updated{" "}
                            {new Date(
                                policy.updated_at
                            ).toLocaleDateString(
                                "en-BW",
                                {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                }
                            )}
                        </Text>

                        <Box
                            className="policy-content"
                            color="gray.700"
                            lineHeight="2"
                            dangerouslySetInnerHTML={{
                                __html:
                                    policy.content,
                            }}
                        />
                    </Box>
                </Box>
            </Flex>
        </Flex>
    );
};

export default PolicyViewer;